module.exports = __webpack_public_path__ + "53fe5ddf1d70207f789c14281cebbfd6.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/media/fonts/GT-Walsheim-Pro-Regular.ttf
// module id = 1243
// module chunks = 0